import type { StaticImageData } from "next/image";
import {
  appStoreLinks as appStoreLinksConfig,
  footerSectionsConfig,
  paymentMethods,
  partnerMethods,
  membershipAffiliationItems,
  socialLinks,
} from "@/utils/constants/layout";

export type FooterLinkItem = {
  label: string;
  href?: string;
  action?: "support_dialog" | "download_app_dialog";
  icon?: "arrow-up-right";
  underline?: boolean;
};

export type FooterIconLinkItem = {
  src: string;
  alt: string;
  href: string;
};

export type FooterPaymentItem = {
  src: string | StaticImageData;
  alt: string;
};

export type FooterStoreLinkItem = {
  href: string;
  icon: string;
  label: string;
  iconWidth: number;
  iconHeight: number;
};

export const footerSections = footerSectionsConfig satisfies Array<{
  title: string;
  items: FooterLinkItem[];
}>;
export const socialItems: FooterIconLinkItem[] = socialLinks;
export const paymentItems: FooterPaymentItem[] = paymentMethods;
export const partnerItems: FooterPaymentItem[] = partnerMethods;
export const membershipItems: FooterPaymentItem[] = membershipAffiliationItems;
export const appStoreLinks: FooterStoreLinkItem[] = appStoreLinksConfig;
